import * as Yup from "yup";
import { localNumber } from "../../../helper/Format";
import { regexList } from "../../../Constants";

export const uploadBillContents = {
  titles: {
    heading: "Provide your Challan details below:",
    EligibilityText: (eligibilityAmount: number, expiryDate: string) =>
      `Your Eligibility Amount Rs ${localNumber(
        eligibilityAmount
      )} expires on ${expiryDate}`
  },
  buttons: {
    submit: "Submit",
    challanFile: "Upload Challan"
  },
  labels: {
    gstin: "Gstin:",
    gstOutAmt: "Current total GST outstanding value:",
    challanId: "Challan ID:",
    challanAmount: "Challan Amount:",
    challanFile: "Select Challan File:",
    processing_fees: 'Processing Fee',
  },
  placeholders: {
    gstin: "Enter gstin",
    gstOutAmt: "Enter GST outstanding value",
    challanId: "Enter Challan ID",
    challanAmount: "Enter Challan Amount",
    processing_fees: 'Enter Processing Fee',
  },
  feedbacks: {
    requiredChallanFile: "Challan File Required",
    fileFormat: "Only PDF Files Accepted"
  }
};

export const ERRORS = {
  required: "Required",
  min: (length: number) => `Must be at greater than ${length}`,
  invalid: "Invalid format",
  challanAmountExcess: (amount: number) =>
    `The challan amount cannot exceed remaining eligibility amount ${localNumber(
      amount
    )}`,
  challanAmountExceedsGstAmt:
    "The challan amount cannot exceed total GST outstanding value",
  processingFeeIsZero:
  "The challan amount cannot be 0"
};

export const challanFileType = ".pdf";

export const uploadBillValidationSchema = (remainingAmount: number) =>
  Yup.object().shape({
    gstOutstandingAmount: Yup.number()
      .required(ERRORS.required)
      .typeError(ERRORS.invalid)
      .min(0, ERRORS.min(0)),
    challanAmount: Yup.number()
      .required(ERRORS.required)
      .typeError(ERRORS.invalid)
      .min(0, ERRORS.min(0))
      .max(remainingAmount, ERRORS.challanAmountExcess(remainingAmount))
      .test({
        name: "challan excess check",
        test(challanAmount) {
          return challanAmount > this.parent.gstOutstandingAmount
            ? this.createError({
                message: ERRORS.challanAmountExceedsGstAmt
              })
            : true;
        }
      }),
    challanId: Yup.string()
      .matches(regexList.alphaNumerical, ERRORS.invalid)
      .required(ERRORS.required),
    processing_fees: Yup.number()
      .required(ERRORS.required)
      .typeError(ERRORS.invalid)
      .min(1,ERRORS.min(1))
      .test({
        name: "processing fee limit check",
        test(processing_fees) {
          return processing_fees === 0
            ? this.createError({
                message: ERRORS.processingFeeIsZero
              })
            : true;
        }
      })
  });
